export const nonRestrictedApis = [
    '/api/method/guidestar.api.user.login',
    '/api/method/guidestar.api.user.data_user_login',
    '/api/method/guidestar.api.user.npo_login',
    'api/method/guidestar.api.npo_registration.npo_registration_search',
    'api/method/guidestar.api.npo_profile_count.get_npo_profile_count',
    'api/method/guidestar.api.user.get_data_user_profile',
    'api/method/guidestar.api.npo_profile.npo_urls',
    'api/method/guidestar.api.npo_profile_summary_page.get_npo_profile_summary',
    'api/method/guidestar.api.npo_profile_programme_page.get_npo_profile_programmes',
    'api/method/guidestar.api.npo_profile_governance_page.get_npo_profile_governance',
    'api/method/guidestar.api.npo_profile_finance_page.get_npo_profile_finance',
    'api/method/guidestar.api.npo_profile_operations_page.get_npo_profile_operations',
    'api/method/guidestar.api.npo_profile_document_page.get_npo_profile_documents',
    'api/method/guidestar.api.user.make_data_user_profile',
]